import { isDirty, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import ExternalInternalForm from '../../../../itrust_common/components/authorised/examFormPartial/ExternalInternalForm';
import { dateTimeFormat } from '../../../../itrust_common/components/HelperFunctions';
import { useEffect } from 'react';

function ExamExternalInternalForm(props) {
  const { handleSubmit, template, exam } = props;

  useEffect(() => {
    return () => {
      if (props.dirty) {
        handleSubmit();
      }
    }
  }, [props.dirty])

  return (
    <form onSubmit={handleSubmit}>
      <ExternalInternalForm pprops={props} exam={exam} template={template} isTemplate={false} />
    </form>
  )
}

ExamExternalInternalForm = reduxForm({
  form: 'examExternalInternalForm',
  enableReinitialize: true
})(ExamExternalInternalForm)

const mapStateToProps = state => {
  const { exam: { exam } } = state
  return {
    exam: exam,
    initialValues: {
      id: exam.id,
      type: exam.patient_tonometries_attributes?.[0]?.method_name || '',
      external_attributes: exam.external_attributes,
      internal_attributes: {
        ...exam.internal_attributes,
        instilled_at: exam.internal_attributes?.instilled_at && dateTimeFormat(exam.internal_attributes?.instilled_at)
      },
      gat: exam.gat,
      nct: exam.nct,
      visual_field: exam.visual_field,
      tonometries_attributes: (exam.tonometries_attributes || [

        ...((exam.gat || [])
          .filter(r => r.is_marked_complete)
          .map(r => ({ type: 'Goldmann', od: r.od, os: r.os, performed_at: r.gat_time, is_marked_complete: true }))),

        ...((exam.nct || [])
          .filter(r => r.is_marked_complete)
          .map(r => ({ type: 'NCT', od: r.od, os: r.os, performed_at: r.nct_time, is_marked_complete: true }))),
      ]).map(r => ({ ...r, patient_id: exam.patient_id }))
    }
  }
}

export default connect(mapStateToProps)(ExamExternalInternalForm)